var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { width: "700px", fullscreen: _vm.fullscreen },
      model: {
        value: _vm.show,
        callback: function($$v) {
          _vm.show = $$v
        },
        expression: "show"
      }
    },
    [
      _c(
        "custom-dialog",
        {
          attrs: {
            fullscreen: _vm.fullscreen,
            color: "accent",
            title: this.generateMessage(
              "actionplans.list_action_not_ended.title"
            )
          },
          on: {
            close: function($event) {
              _vm.show = false
            },
            fullscreen: _vm.handleFullscreenClick
          },
          scopedSlots: _vm._u([
            {
              key: "actions",
              fn: function() {
                return [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mx-2",
                      attrs: { color: "success", small: "" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.validate.apply(null, arguments)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.generateMessage(
                              "actionplans.list_action_not_ended.submit_btn"
                            )
                          ) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "mx-2",
                      attrs: { color: "primary", small: "" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          _vm.show = false
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.generateMessage(
                              "actionplans.list_action_not_ended.cancel_btn"
                            )
                          ) +
                          "\n      "
                      )
                    ]
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("p", [
            _vm._v(
              "\n      " +
                _vm._s(
                  this.generateMessage("actionplans.list_action_not_ended.text")
                ) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c(
            "v-card",
            [
              _c("v-virtual-scroll", {
                attrs: { height: "250", "item-height": "70", items: _vm.items },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function({ item }) {
                      return [
                        _c(
                          "v-list-item",
                          { key: item.id },
                          [
                            _c(
                              "v-list-item-content",
                              [
                                _c("v-list-item-title", [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(item.id) +
                                      " - " +
                                      _vm._s(
                                        item.current_act_status_type_name
                                      ) +
                                      "\n              "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("v-list-item-subtitle", [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(item.description) +
                                      "\n              "
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("v-divider")
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }